module.exports = __webpack_public_path__ + "static/happy-healthy-dog-6b95f95e3fc9cc24590016279e609991.jpg";